'use strict';

var ga4 = require('./ga4');

/**
 * Extracts `pid` querystring value from a product URL.
 * @param {string} href - Link href
 * @returns {string} Product id (pid)
 */
function getPidFromHref(href) {
    if (!href || typeof href !== 'string') {
        return '';
    }

    var match = href.match(/[?&]pid=([^&#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
}

/**
 * Determines the current list/category name.
 * @returns {string} List name
 */
function getListName() {
    var title =
        $('.header.page-title').text().trim() ||
        $('.page-title').first().text().trim();

    return title || 'Category';
}

/**
 * Builds GA4 item objects from the current product grid.
 * @param {JQuery} $grid - Product grid root
 * @returns {Array} GA4 items
 */
function buildItemsFromGrid($grid) {
    var items = [];

    $grid.find('.product-tile').each(function (index) {
        var $tile = $(this);
        var $nameLink = $tile.find('.pdp-link a[data-type="name"]').first();
        var brand = $tile.find('.pdp-link a[data-type="brand"]').first().text().trim();
        var href = $nameLink.attr('href') || '';
        var pid = getPidFromHref(href) || $tile.data('pid');
        var name = $nameLink.text().trim();
        var price = ga4.getFirstPriceValue($tile);

        if (!pid) {
            return;
        }

        var category = $tile.data('category') || '';
        var item = {
            item_id: pid,
            item_name: name || pid,
            price: price,
            index: index + 1,
            item_list_name: getListName(),
            item_category: category
        };

        if (brand) {
            item.item_brand = brand;
        }

        items.push(item);
    });

    return items;
}

/**
 * Generates a stable signature to prevent duplicate sends.
 * @param {string} listName - List name
 * @param {Array} items - GA4 items
 * @returns {string} Signature
 */
function signature(listName, items) {
    var head = items.slice(0, 12).map(function (i) { return i.item_id; }).join('|');
    return listName + '::' + head + '::' + items.length;
}

module.exports = {
    init: function () {
        if (!$('.product-grid').length) {
            return;
        }

        var timerId = null;
        var lastSig = null;

        /**
         * Sends `view_item_list` for the current grid.
         * @returns {void}
         */
        function fire() {
            var listName = getListName();
            var items = buildItemsFromGrid($('.product-grid'));
            if (!items.length) {
                return;
            }

            var sig = signature(listName, items);
            if (sig === lastSig) {
                return;
            }
            lastSig = sig;

            ga4.sendEvent('view_item_list', {
                item_list_name: listName,
                items: items
            });
        }

        /**
         * Debounces firing to wait for DOM updates to settle.
         * @returns {void}
         */
        function schedule() {
            if (timerId) {
                clearTimeout(timerId);
            }
            timerId = setTimeout(fire, 150);
        }

        schedule();

        $('body').on('search:updateDom', function (e, selector) {
            if (selector === '.product-grid' || selector === '.grid-footer' || selector === '.header.page-title') {
                schedule();
            }
        });
    }
};
